var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsFbCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_48_41025)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0042 33.7344C27.6671 33.7344 35.5005 26.2143 35.5005 16.9378C35.5005 7.66123 27.6671 0.141113 18.0042 0.141113C8.3412 0.141113 0.507812 7.66123 0.507812 16.9378C0.507812 26.2143 8.3412 33.7344 18.0042 33.7344Z",
    fill: "#1877F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_41025",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 34
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0042 33.7344C27.6671 33.7344 35.5005 26.2143 35.5005 16.9378C35.5005 7.66123 27.6671 0.141113 18.0042 0.141113C8.3412 0.141113 0.507812 7.66123 0.507812 16.9378C0.507812 26.2143 8.3412 33.7344 18.0042 33.7344Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_41025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.7374 35.134V22.1236H25.2864L25.9644 17.0567H20.7374V13.8233C20.7374 12.3536 21.1602 11.3528 23.3545 11.3528H26.1539V6.81771C25.6728 6.75472 24.0106 6.61475 22.0788 6.61475C18.0473 6.61475 15.2843 8.98027 15.2843 13.3194V17.0567H10.7207V22.1236H15.2843V35.134H20.7374Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_41025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.134277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsFbCircle);
export default __webpack_public_path__ + "static/media/sns_fb_circle.6adbe527066b27247e23d0ef9a013979.svg";
export { ForwardRef as ReactComponent };